// :cow: Cosmose CONFIDENTIAL :iso:
import { Pipe, PipeTransform } from '@angular/core';
import { Series } from '@coa/app/home/modules/compare-feature/models/comparison.response';
import { ScaleTicks } from '@coa/app/shared/chart-js/chartjs-tooltip';

@Pipe({
  name: 'scaleTicks',
})
export class ScaleTicksPipe implements PipeTransform {

  transform(seriesList: Series[][], numberOfValues = 5): ScaleTicks | null {
    if (!seriesList || seriesList.length === 0) {
      return null;
    }

    const absoluteMax = this.getAbsoluteMax(seriesList);
    const distance = this.getDistance(absoluteMax, numberOfValues);

    return {
      min: 0,
      max: distance * numberOfValues,
      stepSize: distance,
    };
  }

  private getDistance(absoluteMax: number, numberOfValues: number): number {
    const absoluteStep = absoluteMax / numberOfValues;
    //numbers divide evenly, already got max distance
    if (absoluteMax % numberOfValues === 0) {
      return absoluteStep;
    }

    const magnitude = this.extractNumberMagnitude(absoluteStep);
    const leadingNumber = this.extractLeadingNumber(absoluteStep);
    let increment = 0;
    let step;

    do {
      step = this.calculateStep(leadingNumber + increment, magnitude);
      increment++;
    } while (step * numberOfValues < absoluteMax);

    return step;
  }

  private calculateStep(leadingNumber: number, magnitude: number): number {
    return leadingNumber * (10 ** (magnitude));
  }

  private extractNumberMagnitude(value: number): number {
    return (value).toFixed(0)
      .toString()
      .length - 1;
  }

  private extractLeadingNumber(value: number): number {
    const parts = value.toString().split('');
    return parseInt(parts.shift());
  }

  private getAbsoluteMax(seriesList: Series[][]): number {
    let max = 0;
    seriesList.forEach(series => {
      series.forEach(data => {
        if (data.value > max) {
          max = data.value;
        }
      });
    });

    return max;
  }
}
